import React, { useContext, useMemo, useState } from "react";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { useCurrentUserData } from "hooks/useUserData";
import { useDataGrid } from "hooks/useDataGrid";
import * as CSC from "SC";
import { GlobalContext } from "store/globalContext";
import { DataGrid } from "UI/DataGrid";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import { AddNewLocationDialog } from "./AddNewLocationDialog";
import { EditLocationDialog } from "./EditLocationDialog";

export const Locations = () => {
  const { userData } = useContext(GlobalContext);
  const disableDownload =
    userData?.role !== "Super Admin" && userData?.role !== "Admin";

  const { isReadOnlyAccess, isSuperAdmin, organizationId } =
    useCurrentUserData();
  const [isAddNewDialogOpen, setIsAddNewDialogOpen] = useState(false);

  const [currentRow, setCurrentRow] = useState("");

  const columns = [
    {
      label: "Name",
      field: "name",
      xs: 3,
      sm: 3,
      md: 3,
      renderer: ({ name }) => (
        <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
      ),
    },
    {
      label: "Address",
      field: "street",
      xs: 4,
      sm: 4,
      md: 4,
      renderer: ({ street, street2, city, state, zipCode }) => (
        <TextFieldWithEllipsis>
          {[street, street2, city, state, zipCode].filter(Boolean).join(", ")}
        </TextFieldWithEllipsis>
      ),
    },
    {
      label: "Phone",
      field: "phone",
      xs: 2,
      sm: 2,
      md: 2,
      renderer: ({ phone }) => (
        <TextFieldWithEllipsis>{phone}</TextFieldWithEllipsis>
      ),
    },
    {
      label: "Speciality",
      field: "speciality",
      xs: 3,
      sm: 3,
      md: 3,
      renderer: ({ speciality }) => (
        <TextFieldWithEllipsis>{speciality}</TextFieldWithEllipsis>
      ),
    },
  ];

  const dataGrid = useDataGrid({
    url: "/locations",
    defaultSorter: {
      name: "name",
      order: "asc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Locations`,
    additionalParams: useMemo(
      () => ({
        recipientId: organizationId,
      }),
      [organizationId]
    ),
  });

  const handleRowClick = (row) => setCurrentRow(row);

  return (
    <CommonOutletTemplate title="Locations" isLoading={!dataGrid?.rows}>
      <DataGrid
        columns={columns}
        handleRowClick={handleRowClick}
        {...dataGrid}
        disableDownload={disableDownload}
        afterSearchContent={
          !isReadOnlyAccess &&
          !isSuperAdmin && (
            <CSC.BlueButton
              variant="outlined"
              onClick={() => setIsAddNewDialogOpen(true)}
            >
              Add New Location
            </CSC.BlueButton>
          )
        }
      />
      {!isReadOnlyAccess && !isSuperAdmin && (
        <AddNewLocationDialog
          open={isAddNewDialogOpen}
          handleClose={() => setIsAddNewDialogOpen(false)}
          refreshList={() => dataGrid.loadData()}
          recipientId={organizationId}
        />
      )}
      <EditLocationDialog
        location={currentRow}
        handleClose={() => setCurrentRow(null)}
        refreshList={() => dataGrid.loadData()}
        recipientId={organizationId}
      />
    </CommonOutletTemplate>
  );
};
